// user.js
export default {
  namespaced: true,

  state() {
    return {
      token: null,
      userInfo: null,
    };
  },

  mutations: {
    SET_TOKEN(state, token) {
      state.token = token;
      window.localStorage.setItem('userToken', token)

    },
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
      window.localStorage.setItem('userInfo', JSON.stringify(userInfo))

    },
    CLEAR_AUTH(state) {
      state.token = null
      state.userInfo = null
    },
  },

  actions: {
    setToken({ commit }, token) {
      commit('SET_TOKEN', token);
    },
    setUserInfo({ commit }, userInfo) {
      commit('SET_USER_INFO', userInfo);
    },
    logout({ commit }) {
      commit('CLEAR_AUTH');
    },
  },

  getters: {
    token: state => state.token,
    userInfo: state => state.userInfo,
  },
};